module.exports = __webpack_public_path__ + "img/content2.0320536c.jpg";